import React from 'react';
import { AlertTriangle, FileText, CheckCircle } from 'lucide-react';

const OutstandingInvoices = ({ data = [], loading = false }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('nl-NL');
  };

  if (loading) {
    return (
      <div className="card-blue">
        <div className="card-header">
          <div style={{ height: '24px', width: '200px', background: 'var(--color-neutral-200)', borderRadius: 'var(--radius-md)' }} className="animate-pulse" />
        </div>
        <div className="card-body">
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
            {[1, 2, 3].map((i) => (
              <div key={i} style={{ height: '64px', background: 'var(--color-neutral-100)', borderRadius: 'var(--radius-lg)' }} className="animate-pulse" />
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className="card-blue">
        <div className="card-header">
          <h3 className="card-title" style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
            <FileText className="w-5 h-5" style={{ color: 'var(--color-success)' }} />
            Openstaande Facturen
          </h3>
        </div>
        <div className="card-body" style={{ textAlign: 'center', padding: 'var(--space-8)' }}>
          <CheckCircle style={{ width: '48px', height: '48px', color: 'var(--color-success)', margin: '0 auto var(--space-3)' }} />
          <p style={{ color: 'var(--color-neutral-500)', fontSize: 'var(--text-sm)' }}>Geen openstaande facturen</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card-blue">
      <div className="card-header">
        <h3 className="card-title" style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
          <AlertTriangle className="w-5 h-5" style={{ color: 'var(--color-warning)' }} />
          Openstaande Facturen ({data.length})
        </h3>
      </div>
      <div className="card-body">
        <div className="invoice-list-blue" style={{ maxHeight: '256px', overflowY: 'auto' }}>
          {data.map((invoice) => (
            <div key={invoice.id} className="invoice-item">
              <div className="invoice-info">
                <span className="invoice-number">
                  {invoice.invoice_id || invoice.invoice_number || invoice.id}
                </span>
                <span className="invoice-date">
                  {formatDate(invoice.invoice_date)}
                </span>
              </div>
              <span className="invoice-amount">
                {formatCurrency(invoice.total_price_incl_tax || 0)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OutstandingInvoices;
